/**
 * Discriminador de evidencia fotográfica para Toolbox (sin preguntas).
 * Toolbox usa plantilla 4 (misma que Amarre) y sube al ítem canónico del primer informe.
 * Coordinar con backend si el valor debe cambiar al sembrar slots propios de toolbox.
 */
export const TOOLBOX_ID_PREGUNTA_ITEM = 1;
